import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=3423e135&scoped=true&"
import script from "./AddressDetails.vue?vue&type=script&lang=js&"
export * from "./AddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./AddressDetails.vue?vue&type=style&index=0&id=3423e135&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423e135",
  null
  
)

export default component.exports